import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { viewRefund } from "../../Redux/Actions/walletRefundAction";
import MainLayout from "../../Layout/mainLayout";
// import toast from "react-hot-toast";
import "./viewRefunds.css";

// const getStatusOptions = (currentStatus) => {
//   switch (currentStatus) {
//     case "requested":
//       return [
//         { label: "Approved", value: "approved" },
//         { label: "Declined", value: "declined" },
//         { label: "Completed", value: "completed" },
//       ];
//     case "approved":
//       return [{ label: "Completed", value: "completed" }];
//     default:
//       return [];
//   }
// };

const statusColorMap = {
  approved: "vr-status--approved",
  declined: "vr-status--declined",
  completed: "vr-status--completed",
  requested: "vr-status--requested",
};

const ViewRefunds = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(viewRefund(id));
  }, [id, dispatch]);

  const { individualRefund } = useSelector((state) => state.refunds);
  const data = individualRefund?.data || {};
  const currentStatus = data?.status || "";
  // const isLocked = currentStatus === "declined" || currentStatus === "completed";
  // const statusOptions = getStatusOptions(currentStatus);

  // const handleStatusChange = async (e) => {
  //   try {
  //     const updatedStatus = e.target.value;
  //     if (!updatedStatus) return;
  //     const response = await dispatch(changeRefundStatus({ refund_id: id, status: updatedStatus }));
  //     const res = response?.payload || response;
  //     if (res?.statusCode === 200) {
  //       await dispatch(viewRefund(id));
  //     } else {
  //       toast.error(res?.message || "Failed to update status");
  //     }
  //   } catch (error) {
  //     toast.error(error?.message || "Error updating status");
  //   }
  // };

  return (
    <MainLayout>
      <div className="vr-wrapper">

        <div className="vr-header">
          <div className="vr-header-left">
            <Link to="/wallet_refund" className="vr-back-btn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              Back
            </Link>
            <div className="vr-header-divider" />
            <div>
              <div className="vr-breadcrumb">Wallet Refund / List / View</div>
              <h1 className="vr-title">{data?.user_id?.name || "Refund Details"}</h1>
            </div>
          </div>
          {currentStatus && (
            <span className={`vr-status-pill ${statusColorMap[currentStatus] || ""}`}>
              {currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1)}
            </span>
          )}
        </div>

        <div className="vr-hero-card">
          <div className="vr-hero-left">
            <div>
              <div className="vr-hero-label">Transaction ID</div>
              <div className="vr-hero-value">{data?.transaction_id || "—"}</div>
            </div>
          </div>
          <div className="vr-hero-meta">
            {data?.user_id?.name && (
              <div className="vr-hero-meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                </svg>
                {data.user_id.name}
              </div>
            )}
            {data?.amount && (
              <div className="vr-hero-meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="12" y1="1" x2="12" y2="23" />
                  <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                </svg>
                {data.amount}
              </div>
            )}
          </div>
        </div>

        <div className="vr-grid-layout">

          <div className="vr-col">

            <div className="vr-card">
              <div className="vr-card-header">
                <span className="vr-card-badge">01</span>
                <h2 className="vr-card-title">Refund Request Details</h2>
              </div>
              <div className="vr-info-grid">
                <div className="vr-info-item" style={{ gridColumn: "span 2" }}>
                  <span className="vr-info-label">Transaction ID</span>
                  <span className="vr-code-value">{data?.transaction_id || "No Data"}</span>
                </div>
                <div className="vr-info-item">
                  <span className="vr-info-label">Amount</span>
                  <span className="vr-info-value">{data?.amount || "No Data"}</span>
                </div>
                <div className="vr-info-item">
                  <span className="vr-info-label">Payment Date</span>
                  <span className="vr-info-value">
                    {data?.created_at ? new Date(data.created_at).toLocaleString() : "No Data"}
                  </span>
                </div>
                <div className="vr-info-item">
                  <span className="vr-info-label">User Name</span>
                  <span className="vr-info-value">{data?.user_id?.name || "No Data"}</span>
                </div>
                <div className="vr-info-item">
                  <span className="vr-info-label">Current Status</span>
                  {currentStatus ? (
                    <span className={`vr-status-pill ${statusColorMap[currentStatus] || ""}`} style={{ width: "fit-content" }}>
                      {currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1)}
                    </span>
                  ) : (
                    <span className="vr-info-value">No Data</span>
                  )}
                </div>
              </div>
            </div>

          </div>

          <div className="vr-col">

            <div className="vr-card">
              <div className="vr-card-header">
                <span className="vr-card-badge">02</span>
                <h2 className="vr-card-title">User's Bank Details</h2>
              </div>
              <div className="vr-info-grid">
                <div className="vr-info-item" style={{ gridColumn: "span 2" }}>
                  <span className="vr-info-label">Account Holder's Name</span>
                  <span className="vr-info-value">{data?.user_id?.bank_detail?.account_holder_name || "No Data"}</span>
                </div>
                <div className="vr-info-item">
                  <span className="vr-info-label">Bank Name</span>
                  <span className="vr-info-value">{data?.user_id?.bank_detail?.bank_name || "No Data"}</span>
                </div>
                <div className="vr-info-item">
                  <span className="vr-info-label">Account Number</span>
                  <span className="vr-code-value vr-code-value--sm">{data?.user_id?.bank_detail?.account_number || "No Data"}</span>
                </div>
              </div>
            </div>

            {/* <div className="vr-card">
              <div className="vr-card-header">
                <span className="vr-card-badge">03</span>
                <h2 className="vr-card-title">Status</h2>
              </div>
              {isLocked ? (
                <div className="vr-locked-notice">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                  <strong>{currentStatus}</strong> 
                </div>
              ) : (
                <div className="vr-info-item">
                  <span className="vr-info-label">Change Status</span>
                  <div className="vr-select-wrap">
                    <select className="vr-select" defaultValue="" onChange={handleStatusChange}>
                      <option value="" disabled>Select an option</option>
                      {statusOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                    <svg className="vr-select-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </div>
                </div>
              )} */}
            {/* </div> */}

          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ViewRefunds;